/**
 * Live now (spec 11 card 1): while a followed meeting is in session, the Meetings page listens to that
 * meeting's MeetingRoom (meeting:{id}) for speaker turns and its status, from the seq the Following
 * snapshot was written at. Opened after paint, like every other channel (§0.6).
 */
import { followingStore } from "../stores/followingStore";
import { LiveChannel } from "./liveClient";
import type { MeetingDelta, MeetingSnapshot } from "./protocol";

export function startLiveNow(meetingId: string): () => void {
  const channel = new LiveChannel({
    url: `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/live/meeting/${encodeURIComponent(meetingId)}`,
    channel: `meeting:${meetingId}`,
    getLastSeq: () => followingStore.getState().live?.seq ?? 0,
    onSnapshot: (data) => followingStore.getState().liveSnapshot(data as MeetingSnapshot),
    onDelta: (seq, d) => followingStore.getState().applyLive(seq, d as MeetingDelta),
  });
  const start = () => channel.start();
  const id = "requestIdleCallback" in window ? window.requestIdleCallback(start, { timeout: 500 }) : setTimeout(start, 0);
  return () => { if ("cancelIdleCallback" in window) window.cancelIdleCallback(id as number); else clearTimeout(id); channel.stop(); };
}
